export default {
  brand: () => import("/var/lib/jenkins/jobs/FRONT/FRONT-INDIE-STUDIO-V3/layouts/brand.vue").then(m => m.default || m),
  default: () => import("/var/lib/jenkins/jobs/FRONT/FRONT-INDIE-STUDIO-V3/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/var/lib/jenkins/jobs/FRONT/FRONT-INDIE-STUDIO-V3/layouts/empty.vue").then(m => m.default || m)
}